import { render, staticRenderFns } from "./AdminDashboardScreen.vue?vue&type=template&id=5612c5e6&scoped=true&"
var script = {}
import style0 from "./AdminDashboardScreen.vue?vue&type=style&index=0&id=5612c5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612c5e6",
  null
  
)

export default component.exports